import {environment} from '../../../environments/environment';

export const serviceAuthToken = environment.api_authorization_token;
export const serviceAuthHeader = 'Bearer ' + serviceAuthToken;
